import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createVisitImageAction, getVisitImagesActions } from '../../../redux/actions/visitImagesActions';
import { imageRequest } from '../../../utils/requestMapper';
import { UploadImageButton } from '../../shared/buttons/UploadImageButton';
import ContainerHeader from '../../shared/container/ContainerHeader';
import ContainerTitle from '../../shared/container/ContainerTitle';

const VisitImagesHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit.visit);
  const [loading, setLoading] = useState(false);

  const handleImageSelect = async (event) => {
    setLoading(true);
    const { files } = event.target;
    if (files && files.length >= 1) {
      const image = imageRequest(files);
      await dispatch(createVisitImageAction(vin, id, image));
      await dispatch(getVisitImagesActions(vin, id));
    }
    setLoading(false);
  };

  return (
    <ContainerHeader>
      <ContainerTitle title={'Фотографії візиту'} />
      {!readOnly && <UploadImageButton loading={loading} onImageSelect={handleImageSelect} />}
    </ContainerHeader>
  );
};

export default memo(VisitImagesHeader);
